/**
 * Plan Feature Limitation Configuration
 * Path: money_guardian > [safeguard_type] > max_rules
 */
export const PLAN_FEATURE_LIMITS = {
  fi_free: {
    money_guardian: {
      spend_safeguards: { max_rules: 0 },
      credit_safeguards: { max_rules: 1 },
    },
  },
  fi_paid_basic: {
    money_guardian: {
      spend_safeguards: { max_rules: 5 },
      credit_safeguards: { max_rules: 5 },
    },
  },
};

export const DEFAULT_PLAN_CODE = "fi_free";

/**
 * Gets the maximum rule limit for a specific safeguard feature path.
 * @param {string} planCode User plan code string
 * @param {'spend_safeguards' | 'credit_safeguards'} safeguardType Feature key
 * @returns {number} Allowed rule limit
 */
export const getSafeguardRuleLimit = (planCode, safeguardType) => {
  const code = PLAN_FEATURE_LIMITS[planCode] ? planCode : DEFAULT_PLAN_CODE;
  return (
    PLAN_FEATURE_LIMITS[code]?.money_guardian?.[safeguardType]?.max_rules ?? 1
  );
};
